module.exports = __webpack_public_path__ + "static/media/risk-level.5cc7c739.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainmenus/risk-level.png
// module id = 2930
// module chunks = 0